import type { IconData } from '@stacksjs/iconify-core'

export const fi4x3: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h640v480H0z\"/><path fill=\"#002f6c\" d=\"M0 174.5h640v131H0z\"/><path fill=\"#002f6c\" d=\"M175.5 0h130.9v480h-131z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default fi4x3
